import type { z } from 'zod';

import {
  DelayResponseFormSchema,
  FunctionErrorFormSchema,
  FunctionFormSchema,
  FunctionLatencyControlFormSchema,
  FunctionParameterFormSchema,
  FunctionParameterTypeSchema,
} from '@polyai/schemas';

export type FunctionTabs = 'definition' | 'delay_control';

// Re-export schemas from @polyai/schemas with Jupiter naming conventions
export const parameterTypeSchema = FunctionParameterTypeSchema;
export const streamFunctionParameter = FunctionParameterFormSchema;
export const streamFunctionErrorSchema = FunctionErrorFormSchema;
export const streamDelayResponseSchema = DelayResponseFormSchema;
export const streamFunctionLatencyControlSchema =
  FunctionLatencyControlFormSchema;
export const streamFunctionSchema = FunctionFormSchema;

// Re-export types
export type StreamFunctionLatencyControl = z.infer<
  typeof streamFunctionLatencyControlSchema
>;
export type StreamDelayResponse = z.infer<typeof streamDelayResponseSchema>;
export type StreamFunctionError = z.infer<typeof streamFunctionErrorSchema>;
export type StreamFunctionParameter = z.infer<typeof streamFunctionParameter>;
export type StreamFunctionForm = z.infer<typeof streamFunctionSchema>;
